import { useMemo } from "react";

import FieldFeature from "@mapmycustomers/shared/enum/fieldModel/FieldFeature";
import TypedEntity from "@mapmycustomers/shared/types/base/TypedEntity";
import HasAccessInformation from "@mapmycustomers/shared/types/entity/common/HasAccessInformation";
import { LayoutSchemaField } from "@mapmycustomers/shared/types/layout/FormLayout";

import getFieldModelByEntityType, {
  EntityTypeWithFieldModel,
} from "@app/util/fieldModel/getByEntityType";

const useBlankRequiredPrivateFields = <
  E extends Exclude<EntityTypeWithFieldModel, "universal">,
  T extends HasAccessInformation & TypedEntity<E>
>(
  schema: LayoutSchemaField[],
  entityType: E,
  record: T
): LayoutSchemaField["field"][] =>
  useMemo(() => {
    if (!record.accessStatus?.blankPrivateFields?.length) {
      return [];
    }

    const fieldModel = getFieldModelByEntityType(entityType);
    const requiredFieldsSet = new Set(
      schema
        .filter((schemaField) => {
          if (schemaField.required) {
            return true;
          }
          const field = fieldModel.getByPlatformName(schemaField.field);
          // we assume field is required via isSystemRequired only if it's not a relationship field
          return (
            field && field.isSystemRequired && !field.hasFeature(FieldFeature.ASSOCIATED_ENTITY)
          );
        })
        .map(({ field }) => field)
    );

    return record.accessStatus?.blankPrivateFields.filter((field) => requiredFieldsSet.has(field));
  }, [schema, entityType, record]);

export default useBlankRequiredPrivateFields;
